import { configureStore } from '@reduxjs/toolkit';

import authReducer from './slices/authSlice';
import periodsReducer from './slices/periodsSlice';
import tasksReducer from './slices/tasksSlice';
import leaderboardReducer from './slices/leaderboardSlice';
import parametersReducer from './slices/parametersSlice';
import metadataReducer from './slices/metadataSlice';
import dashboardReducer from './slices/dashboardSlice';
import referencesReducer from './slices/referencesSlice';
import uiReducer from './slices/uiSlice';
import auditReducer from './slices/auditSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    periods: periodsReducer,
    tasks: tasksReducer,
    leaderboard: leaderboardReducer,
    parameters: parametersReducer,
    metadata: metadataReducer,
    dashboard: dashboardReducer,
    references: referencesReducer,
    ui: uiReducer,
    audit: auditReducer,
  },
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: {
        // postMessage event detaylarını serializable-check dışı tut
        ignoredActions: ['auth/tokenReceived'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export default store;
